// @flow
import axios from 'lib/defaultClient';

export type EmailLoginPayload = { email: string, password: string, next?: ?string };

export const emailLogin = ({ email, password, next }: EmailLoginPayload): Promise<*> =>
  axios.post('/auth/email-login', {
    email,
    password,
    next,
  });

export type SendAuthEmailPayload = { email: string, next?: ?string };

export const sendAuthEmail = ({ email, next }: SendAuthEmailPayload): Promise<*> =>
  axios.post('/auth/send-auth-email', {
    email,
    next,
  });

export const getCode = (code: string): Promise<*> => axios.get(`/auth/code/${code}`);

export const changePassword = (password: string): Promise<*> =>
  axios.put('/auth/password', {
    password,
  });

type RegisterForm = {
  username: string,
  mobile: string,
  bizNumber: string,
  shortBio: string,
  displayName: string,
  fallbackEmail?: string,
};

export type LocalRegisterPayload = {
  registerToken: string,
  form: RegisterForm,
};

export const localRegister = ({ registerToken, form }: LocalRegisterPayload): Promise<*> =>
  axios.post('/auth/register/local', {
    registerToken,
    form,
  });

export const codeLogin = (code: string): Promise<*> => axios.post('/auth/code-login', { code });
export const check = (): Promise<*> => axios.get('/auth/check');
export const logout = (): Promise<*> => axios.post('/auth/logout');

export type VerifySocialPayload = { provider: string, accessToken: string };
export const verifySocial = ({ provider, accessToken }: VerifySocialPayload) =>
  axios.post(`/auth/verify-social/${provider}`, { accessToken });

export type SocialRegisterPayload = {
  provider: string,
  accessToken: string,
  form: RegisterForm,
};
export const socialRegister = ({ provider, accessToken, form }: SocialRegisterPayload) =>
  axios.post(`/auth/register/${provider}`, {
    accessToken,
    form,
  });

export type SocialLoginPayload = { provider: string, accessToken: string };
export const socialLogin = ({ provider, accessToken }: SocialLoginPayload) =>
  axios.post(`/auth/login/${provider}`, { accessToken });

export type GetProviderTokenPayload = { key: string, type: string };

export const getProviderToken = (payload: GetProviderTokenPayload) =>
  axios.get(`/auth/callback/token?key=${payload.key}`);

export const certifyEmail = (code: string) => axios.post(`/auth/certify?code=${code}`);

// SSO 로그인 URL 가져오기
export const getSsoLoginUrl = (next?: ?string): Promise<*> =>
  axios.get('/auth/sso/login', { params: { next } });

// SSO 회원가입 URL 가져오기
export const getSsoSignupUrl = (next?: ?string): Promise<*> =>
  axios.get('/auth/sso/signup', { params: { next } });

// SSO 로그아웃 URL 가져오기
export const getSsoLogoutUrl = (redirectUri?: ?string): Promise<*> =>
  axios.get('/auth/sso/logout', { params: { redirect_uri: redirectUri } });



// WEBPACK FOOTER //
// ./src/lib/api/auth.js